var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurveyLine = function SvgSurveyLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 3v1.8h2.706c.494 0 .894.4.894.894v14.412c0 .493-.4.894-.894.894H5.294a.894.894 0 0 1-.894-.894V5.694c0-.494.4-.894.894-.894H8V3zM8 6.6H6.2v12.6h12.6V6.6H17v1.8H8zm1.8 9v1.8H8v-1.8zm0-2.7v1.8H8v-1.8zm0-2.7V12H8v-1.8zm5.4-5.4H9.8v1.8h5.4z"
  })));
};
export default SvgSurveyLine;